import PropTypes from "prop-types";
import CategoryPreviewCarouselSkeleton from "./CategoryPreviewCarouselSkeleton";
import CategoryPreviewCarousel from "./CategoryPreviewCarousel";
import styles from "./CategoryPreviewCarouselContainer.css";
import useFetchCategoryPreviewData from "../useFetchCategoryPreviewData";
import {
  CAROUSEL_PRODUCT_REQUEST_LIMIT,
  CAROUSEL_ID,
  MINIMUM_SEARCH_RESULTS_FOR_CAROUSEL,
} from "./constants";
import { withTranslation } from "../../translation";

const CategoryPreviewCarouselContainer = ({
  categoryId,
  formatTranslation,
  ...rest
}) => {
  const queryParams = {
    limit: CAROUSEL_PRODUCT_REQUEST_LIMIT,
    excludeFacets: true,
  };

  const { isError, isLoading, products, itemCount, categoryName, categoryUrl } =
    useFetchCategoryPreviewData({
      cid: categoryId,
      params: queryParams,
    });

  if (
    isError ||
    (!isLoading && products?.length < MINIMUM_SEARCH_RESULTS_FOR_CAROUSEL)
  ) {
    return null;
  }

  return (
    <section
      id={CAROUSEL_ID}
      className={styles.container}
      aria-label={formatTranslation("accessibility_plp_carousel_generic_title")}
    >
      {isLoading ? (
        <CategoryPreviewCarouselSkeleton />
      ) : (
        <CategoryPreviewCarousel
          categoryName={categoryName}
          products={products}
          itemCount={itemCount}
          categoryId={categoryId}
          categoryUrl={categoryUrl}
          {...rest}
        />
      )}
    </section>
  );
};

CategoryPreviewCarouselContainer.propTypes = {
  categoryId: PropTypes.number.isRequired,
  formatTranslation: PropTypes.func.isRequired,
};

export default withTranslation(CategoryPreviewCarouselContainer);
